import { Component, OnInit } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-maes-diogelwch',
    templateUrl: './maes-diogelwch.component.html',
    styleUrls: ['./maes-diogelwch.component.scss'],
    imports: [FaIconComponent, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, FormlyModule, UpperCasePipe, TranslatePipe]
})
export class MaesDiogelwchComponent extends FieldArrayType implements OnInit {

  //@ViewChildren('maesform', { read: ViewContainerRef }) maesforms: QueryList<ViewContainerRef>;

  indexWediAgor: number;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  agorGrwp(i: number) {
    this.indexWediAgor = i;

    //this.field.templateOptions.agorGrwp();

    // if (this.maesforms) {

    //   let rhestr = this.maesforms.toArray();

    //   let maesform = rhestr[i];

    //   const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
    //     MaesDiogelwchFormComponent
    //   );

    //   const componentRef = maesform.createComponent(componentFactory);

    //   componentRef.instance.field = field;
    // }
  }

  wediAgor(i: number) {
    if (i === this.indexWediAgor) {
      return true;
    }
  }
}
